export class ObjectUtils {
    public static isNullOrUndefined(object: any): boolean {
        return object === null || object === undefined;
    }
}
